import ComparisonOperators from "../../consts/DataSourceModule/ComparisonOperators";

abstract class FilterParameterDto {
    Id: number;
    FieldReferenceId: number;
    Operator: ComparisonOperators;

    constructor(id: number, fieldReferenceId: number, operator: ComparisonOperators) {
        this.Id = id;
        this.FieldReferenceId = fieldReferenceId;
        this.Operator = operator;
    }
}

export default FilterParameterDto;
